<template>
  <router-view></router-view>
</template>
<script>
import RegisterStoreModule from '@/mixins/RegisterStoreModule'
import locationStore from './store.js'

export default {
  name: 'location',
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule('location', locationStore)
  },
}
</script>
